/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */
import { convertToError } from '@atlaskit/frontend-utilities/convert-to-error';
import { FetchError as IntegrationsFetchError } from '@atlassian/integrations';
import { FetchError } from './helpers';
import type { FailedFetchAttributes } from './types';

export const makeAri = (productId: string, cloudId: string) =>
	`ari:cloud:${productId}::site/${cloudId}`;

// extends unknown is to avoid type error when using Generics with arrow functions
// mutates cache reference, will clear once it gets too large.
export const tryCacheWithClear = <Type extends unknown>(
	cache: Map<string, Type>,
	key: string,
	value: Type,
	size = 50,
) => {
	if (cache.size >= size) {
		cache.clear();
	}

	cache.set(key, value);
};

export const resolveError = (errorResponse: unknown): FailedFetchAttributes => {
	if (errorResponse instanceof FetchError) {
		return {
			error: errorResponse,
			errorMessage: errorResponse.message,
			responseCode: errorResponse.responseCode,
		};
	}
	if (errorResponse instanceof IntegrationsFetchError) {
		return {
			error: errorResponse,
			errorMessage: errorResponse.message,
			responseCode: errorResponse.statusCode,
		};
	}
	if (errorResponse instanceof Error) {
		return { error: errorResponse, errorMessage: errorResponse.message };
	}
	const error = convertToError(errorResponse);
	return { error, errorMessage: error.message };
};
